/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditCardDTO
 */
export interface CreditCardDTO {
    /**
     * 
     * @type {string}
     * @memberof CreditCardDTO
     */
    cardDetails: string;
}

/**
 * Check if a given object implements the CreditCardDTO interface.
 */
export function instanceOfCreditCardDTO(value: object): value is CreditCardDTO {
    if (!('cardDetails' in value) || value['cardDetails'] === undefined) return false;
    return true;
}

export function CreditCardDTOFromJSON(json: any): CreditCardDTO {
    return CreditCardDTOFromJSONTyped(json, false);
}

export function CreditCardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCardDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'cardDetails': json['cardDetails'],
    };
}

export function CreditCardDTOToJSON(value?: CreditCardDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cardDetails': value['cardDetails'],
    };
}

